import { useState, useEffect } from 'react';
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BpmService } from "../../../core/services/BpmService";
import { BasicTable } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import { ListMenu } from '../../theme/Component/ListMenu';
import { useDashboardStore } from '../../pages/hooks/useDashboardStore';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { JsonFormaterInput } from '../../theme/Component/JsonFormaterInput';

interface Props {
    IDProcedure: any;
}

export const ProcedureAction = ({ IDProcedure }: Props) => {
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Historico de invocaión del servicio', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });


    const [respJson, setRespJson] = useState<any[]>([]);

    useEffect(() => {
        getTramites();
    }, [IDProcedure]);

    const getTramites = () => {
        setLoading(true);
        service.getProcedureActionByProcedureImp(IDProcedure).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let list = resp.DataBeanProperties.ObjectValue;
                    list.forEach((ele: any) => {
                        if (ele.DataBeanProperties.FormCode == null) {
                            ele.DataBeanProperties.FormCode = "NA";
                        }
                        if (ele.DataBeanProperties.ResponseJsonValue == null) {
                            ele.DataBeanProperties.ResponseJsonValue = "NA";
                        }
                    });

                    setLista(list);
                }
                setLoading(false);
            }
        );
    };

    const invokeService = () => {
        _single.spinner(true);
        service.invokeJsonServiceByIDAction(bean.IDAction).subscribe(
            (resp: any) => {
                console.log(resp);

                getTramites();
                toast.success('Servicio invocado correctamente');
                _single.spinner(false);
            }
        );
    }
    const restartStageForProcedureImp = () => {
        _single.spinner(true);
        service.restartStageForProcedureImp(bean.IDProcedureImp, bean.IDStage).subscribe(
            (resp: any) => {
                console.log(resp);

                getTramites();
                toast.success('Servicio invocado correctamente');
                _single.spinner(false);
            }
        );
    }


    const listaBotones = () => {
        const botones = [
            { titulo: 'Invocación del servicio', icono: 'ri-alarm-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Respuesta del servicio', icono: 'ri-chat-1-line', visible: true, evento: () => { setModalR({ ...modalR, "view": true }) } },
            { titulo: 'Ejecutar Servicio', icono: 'ri-chat-1-line', visible: bean.InvokedDate, evento: invokeService },
            { titulo: 'Regresar a este paso', icono: 'ri-chat-1-line', visible: true, evento: restartStageForProcedureImp },
        ];
        return (
            <ListMenu listaBotones={botones}></ListMenu>
        );
    };

    const setRowBean = (bean: any) => {
        //console.log("Row : ", bean);
        setBean(bean);

        if (bean.InvokedRVJsonValue && bean.InvokedRVJsonValue !== "NA") {
            try {
                const parsedJson = JSON.parse(bean.InvokedRVJsonValue);
                setRespJson(parsedJson);
                //console.log(parsedJson);
            } catch (error) {
                console.error("Error al parsear JSON:", error);
            }
        } else {
            setRespJson([])
            //console.log(respJson)
        }
    };

    const head = [
        { title: 'ID', property: 'IDDocument' },
        { title: 'Área encargada', property: 'FunctionalIDName' },
        { title: 'Etapa', property: 'ProcedureName' },
        { title: 'Responsable', property: 'AccountName' },
        { title: 'Tipo de actividad', property: 'ActivityTypeName' },
        { title: 'Nombre de documento', property: 'ProcedureActionName' },
        { title: 'Tipo de documento', property: 'DocumentTypeName' },
        { title: 'Estado', property: 'StateName' },
        { title: 'Código de Formulario', property: 'FormCode' },
        { title: 'Es opcional', property: 'IsOptional' },
        { title: 'Datos documentos', property: 'ResponseJsonValue' },
    ];

    return (
        <>

            <BasicTable body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()}></BasicTable>


            <Modal modal={modal} updateModal={setModal}>
                <>
                    {bean.InvokedValidated != null &&
                        <>
                            <div className="row">
                                <div className="col-md-12 overflow-auto">
                                    <table className="table table-nowrap mb-0">

                                        <tr>

                                            <td colSpan={2}><JsonFormaterInput _label='Mensaje Enviado Al Servicio' inputType='string' value={bean.InvokedMsgJsonValue} onChange={() => { }} returnType='string' /></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><JsonFormaterInput _label='Mensaje recibido del Servicio' inputType='string' value={bean.ResponseJsonValue} onChange={() => { }} returnType='string' /></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <label>Mensaje de Error</label>
                                                <textarea name="texta" id="" className='form-control' value={bean.InvokedErrorMsg}></textarea>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </>
                    }
                    {bean.InvokedValidated == null &&
                        <>
                            <div className="row">
                                <div className="col-md-12" style={{ textAlign: 'center' }}>
                                    <h3>
                                        <strong>El servicio no fue utilizado</strong>
                                    </h3>
                                </div>
                            </div>
                        </>
                    }
                </>
            </Modal>

        </>
    );
};
